import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/screens/plan/constants/planCheckupRingTokens";
import type { PlanCheckupDomainId } from "./planCheckupTypes";

const I18n = I18nUtil.createScoped(Translations);

/** Figma `45420:27383` / `45169:22365` — track donut + progress band */
export const PLAN_CHECKUP_RING_COLORS = {
  /** `#03262B` @ 8% — not solid `#03252B` stroke */
  track: "rgba(3, 38, 43, 0.08)",
  label: "#01262B",
  arcByDomain: {
    financial_security: "#C0BAA7",
    cash_optimization: "#6A9BCC",
    wealth_building: "#4E9675",
    life_decisions: "#DC6803",
  } satisfies Record<PlanCheckupDomainId, string>,
} as const;

export const PLAN_CHECKUP_RING_GEOMETRY = {
  sizePx: 62,
  /** outer r=31, inner r=24.18 → band 6.82px (Figma export) */
  outerRadius: 31,
  innerRadius: 24.18,
  ringWidth: 6.82,
  midRadius: 27.59,
  iconSizePx: 24,
  /** Figma leaves ~0.27% gap at 12 o'clock */
  maxSweepRatio: 359.5 / 360,
} as const;

/** easeInSine 弧长动画 — SPEC §4.5 */
export const PLAN_CHECKUP_RING_ANIMATION = {
  durationMs: 900,
} as const;

/** t ∈ [0, 1] */
export function planCheckupEaseInSine(t: number): number {
  return 1 - Math.cos((t * Math.PI) / 2);
}

export const PLAN_CHECKUP_DOMAIN_ORDER: PlanCheckupDomainId[] = [
  "financial_security",
  "cash_optimization",
  "wealth_building",
  "life_decisions",
];

const PLAN_CHECKUP_DOMAIN_LABEL_KEYS: Record<PlanCheckupDomainId, string> = {
  financial_security: "Financial Security",
  cash_optimization: "Cash Optimization",
  wealth_building: "Wealth Building",
  life_decisions: "Life Decisions",
};

export function getPlanCheckupDomainLabel(
  domainId: PlanCheckupDomainId,
  locale?: string,
): string {
  return I18n.t(
    PLAN_CHECKUP_DOMAIN_LABEL_KEYS[domainId],
    locale ? { locale } : undefined,
  );
}

export const PLAN_CHECKUP_RING_LABEL = {
  stackedWrapperClass:
    "body_s w-full text-center text-content_primary flex items-center justify-center",
  lineClass: "leading-4 w-[72px]",
} as const;

/** Figma ring center icons — exported SVG (`45169:22365`) */
export const PLAN_CHECKUP_RING_ICON_SRC: Record<PlanCheckupDomainId, string> = {
  financial_security: "/assets/plan-checkup/icons/check-shield.svg",
  cash_optimization: "/assets/plan-checkup/icons/dollar-bag.svg",
  wealth_building: "/assets/plan-checkup/icons/plant.svg",
  life_decisions: "/assets/plan-checkup/icons/heart.svg",
};
